import { html, nothing, css } from 'lit';
import { MobxLitElement } from '@adobe/lit-mobx';
import '@digital-realty/ix-icon-button/ix-icon-button.js';
import { NotificationsState } from '../../state/NotificationState.js';
import { TWStyles } from '../../tw.js';

class NotificationsIcon extends MobxLitElement {
  _notificationsState = NotificationsState;

  static get styles() {
    return [
      TWStyles,
      css`
        .unread {
          padding: 0 5px;
          font-size: 12px;
          line-height: 16px;
          left: 18px;
          top: -6px;
          background: var(--clr-critical, #db0028);
        }
      `,
    ];
  }

  renderUnReadCountText() {
    if (this._notificationsState.unreadNotificationCount <= 0) {
      return html` ${nothing} `;
    }

    let unreadCountText = '';
    if (this._notificationsState.unreadNotificationCount > 99) {
      unreadCountText = '99+';
    } else {
      unreadCountText =
        this._notificationsState.unreadNotificationCount.toString();
    }

    return html`
      <div
        class="unread rounded-full text-center text-white text-sm absolute icon-position -start-0"
        data-testid="notification-unread-count"
        role="status"
      >
        ${unreadCountText}
      </div>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  toggleNotificationsDrawer = () => {
    window.dispatchEvent(new CustomEvent('ix-notifications-toggle-drawer'));
  };

  render() {
    return html`
      <div class="relative">
        <ix-icon-button
          style="--md-icon-button-icon-size:29px;"
          class="flex"
          @click=${() => this.toggleNotificationsDrawer()}
          small
          aria-label="Open notifications"
        >
          <svg
            slot="default"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            class="fill-primary"
          >
            <path
              d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
            ></path>
          </svg>
        </ix-icon-button>
        ${this.renderUnReadCountText()}
      </div>
    `;
  }
}

window.customElements.define('notifications-icon', NotificationsIcon);
